import { createContext, useContext } from 'react';
import type { TourContextValue } from './types';

const noop = () => {};

const fallbackTourContext: TourContextValue = {
  currentStep: null,
  isActive: false,
  drawerCaptionIndex: 0,
  start: noop,
  next: noop,
  skip: noop,
  goTo: noop,
  registerTargetRef: noop,
  getTargetRef: () => null,
  notifyDrawerOpened: noop,
  notifyFirstMessageSent: noop,
};

export const TourContext = createContext<TourContextValue>(fallbackTourContext);

export function useTour(): TourContextValue {
  return useContext(TourContext);
}
